import { AloftArea, AloftPrice } from '@aloft/toolkit-shared';

import { Flex } from '../../../summary/components/Flex.js';
import { Td } from '../../../summary/components/Td.js';
import { Tr } from '../../../summary/components/Tr.js';
import { Typography } from '../../../summary/components/Typography.js';
import { COST_APPROACH_COLUMN_WIDTHS } from '../constants.js';

export const CostApproachSummaryRow = ({
  label,
  row,
}: {
  label: string;
  row:
    | {
        sqft?: AloftArea;
        costPerSqft?: AloftPrice;
        totalCost?: AloftPrice;
      }
    | undefined;
}) => (
  <Tr>
    <Td width={COST_APPROACH_COLUMN_WIDTHS[0]} isFirstColumn={true}>
      <Typography variant="body1">{label}</Typography>
    </Td>
    <Td width={COST_APPROACH_COLUMN_WIDTHS[1]} colSpan={3}>
      <Typography variant="body1">{row?.sqft?.toString() ?? ''}</Typography>
    </Td>
    <Td width={COST_APPROACH_COLUMN_WIDTHS[2]} colSpan={3}>
      <Typography variant="body1">
        {row?.costPerSqft ? `${row.costPerSqft.toString()} per sqft` : ''}
      </Typography>
    </Td>
    <Td width={COST_APPROACH_COLUMN_WIDTHS[3]}>
      <Flex justifyContent="flex-end">
        <Typography textAlign="right" variant="body1">
          {row?.totalCost ? `= ${row.totalCost.toString(true)}` : ''}
        </Typography>
      </Flex>
    </Td>
  </Tr>
);
